import ApiService from '~~commonAPIs/ApiService';

const CPBL = {
  listAllPlayer: ({ uniqid }) => {
    return ApiService.get(`/api/cpbl/players?uniqid=${uniqid}`);
  },

  mergePlayer: ({ mainUniqid, subUniqids }) => {
    return ApiService.put(`/api/cpbl/players/merge/${mainUniqid}?sub=${subUniqids.join('&sub=')}`);
  },

  dedupeSeasonTeamPlayers: ({ seasonUniqid, apply = false }) => {
    return ApiService.put(`/api/cpbl/season_team_players/dedupe/${seasonUniqid}${apply ? '?apply=true' : ''}`);
  },
};

export default CPBL;
